import React from 'react';

import PlayerInviteCard from '../cards/PlayerInviteCard';
import EmailInviteCard from '../cards/EmailInviteCard';
import styles from './playerInvite.scss';
import { sportTypeIds } from '../../utils/eventConstants';

const PlayerInvite = ({
    isCreatePlay,
    invitedMembers,
    invitedEmails,
    previousInvites,
    organizer,
    onRemovePlayer,
    onRemoveEmail,
    onInvitePlayerPressed,
    sportTypeId = sportTypeIds.TENNIS,
}) => {
    const handleOnInviteButtonClicked = (event) => {
        event.preventDefault();
        onInvitePlayerPressed();
    };

    const handleOnRemovePlayer = (playerId) => {
        onRemovePlayer(playerId);
    };

    const handleOnRemoveEmail = (email) => {
        onRemoveEmail(email);
    };
    const previouslyInvitedIds = previousInvites.members.map(member => member.source.id);
    const previouslyInvitedEmails = previousInvites.nonMembers.map(player => player.email);

    return (
        <div>
            <div className={styles.title}>Players (Optional)</div>
            <PlayerInviteCard player={organizer} isOrganizer={true} sportTypeId={sportTypeId} />
            {invitedMembers.map(player => {
                const isPreviousInvite = previouslyInvitedIds.includes(player.source.id);
                return (
                    <div key={player.source.id} className={styles.cardContainer}>
                        <PlayerInviteCard
                            player={player}
                            isOrganizer={false}
                            showRemoveButton={!isPreviousInvite}
                            onRemovePlayer={handleOnRemovePlayer}
                            sportTypeId={sportTypeId}
                        />
                    </div>
                );
            })}
            {invitedEmails.map(player => {
                const isPreviousInvite = previouslyInvitedEmails.includes(player.email);
                return (
                    <div key={player.email} className={styles.cardContainer}>
                        <EmailInviteCard
                            email={player.email}
                            onRemoveEmail={handleOnRemoveEmail}
                            showRemoveButton={!isPreviousInvite}
                        />
                    </div>
                );
            })}
            <button type="button" onClick={handleOnInviteButtonClicked} className={styles.button}>
                <div className={styles.inviteButton}>
                    <div className="link">
                        {`${isCreatePlay ? 'Invite from your group or leave blank' : 'Invite player or group (Optional)'}`}
                    </div>
                </div>
            </button>
        </div>
    );
};

export default PlayerInvite;
